export default (state = false, action) => {
    let { type, payload } = action
    switch (type) {
        case 'EXPAND_HUNT_PLANNER_MORE_FILTER':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}
